import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ShopHeader } from "@/components/ShopHeader";
import { ShopFooter } from "@/components/ShopFooter";
import { StoreNav } from "@/components/StoreNav";
import { useLang } from "@/context/LanguageContext";
import { CaretRight } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const IC = "/cat-icons/";

// Top-level catalog categories in the exact order/icons of the legacy site.
const ITEMS = [
  { id: "863", icon: "balais-brosses-et-vadrouilles.png", fr: "Balais brosses et vadrouilles" },
  { id: "917", icon: "securite.png", fr: "Sécurité" },
  { id: "938", icon: "tapis.png", fr: "Tapis" },
  { id: "937", icon: "polisseuses-et-tampons.png", fr: "Polisseuses et tampons" },
  { id: "936", icon: "produits-pour-agro-alimentaire.png", fr: "Produits pour Agro-alimentaire" },
  { id: "935", icon: "emballages.png", fr: "Emballages" },
  { id: "934", icon: "chiffons.png", fr: "Chiffons" },
  { id: "933", icon: "automobile.png", fr: "Automobile" },
  { id: "932", icon: "accessoires-divers.png", fr: "Accessoires-divers" },
  { id: "929", icon: "tampons-et-eponges.png", fr: "Tampons et Éponges" },
  { id: "920", icon: "soins-et-hygiene-corporelle.png", fr: "Soins et hygiène corporelle" },
  { id: "915", icon: "sac-a-ordures-et-autres-sacs.png", fr: "Sacs à ordures et autres sacs" },
  { id: "867", icon: "chariots-seaux-et-essoreuses-1.png", fr: "Chariots seaux et essoreuses" },
  { id: "913", icon: "produits-pour-lessive.png", fr: "Produits pour Lessive" },
  { id: "911", icon: "produits-pour-lave-vaisselle-1.png", fr: "Produits pour lave-vaisselle" },
  { id: "906", icon: "produits-de-pharmacie-et-de-soins.png", fr: "Produits de pharmacie et de soins" },
  { id: "900", icon: "produits-de-papier.png", fr: "Produits de papier" },
  { id: "890", icon: "produits-d-entretien.png", fr: "Produits d’entretien" },
  { id: "885", icon: "poubelles-et-corbeilles.png", fr: "Poubelles et Corbeilles" },
  { id: "883", icon: "gants.png", fr: "Gants" },
  { id: "879", icon: "equipements-assortis.png", fr: "Équipements assortis" },
  { id: "871", icon: "distributrices-doseurs-1.png", fr: "Distributrices-doseurs" },
  { id: "869", icon: "couches-et-lingettes.png", fr: "Couches et Lingettes" },
  { id: "939", icon: "services.png", fr: "Services" },
  { id: "100000", icon: "produits-ecologiques.png", fr: "Produits Écologiques" },
];

export default function CatalogPage() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const [names, setNames] = useState({});

  useEffect(() => {
    axios.get(`${API}/shop/categories`).then((r) => {
      const m = {};
      (r.data || []).forEach((c) => { m[c.category_id] = c.name; });
      setNames(m);
    }).catch((e) => { console.error("catalog categories load failed", e); });
  }, []);

  const label = (it) => (names[it.id] ? (names[it.id][lang] || names[it.id].fr) : it.fr);

  return (
    <div className="min-h-screen bg-[#f4f7f9]">
      <ShopHeader />
      <div className="mx-auto max-w-[1280px] px-4 py-4"><StoreNav active="catalog" /></div>

      <div className="mx-auto max-w-[1280px] px-4 pb-10">
        <div className="mb-6 flex items-center gap-1 text-xs text-muted-foreground">
          <button onClick={() => navigate("/")} className="hover:text-primary">{t.home}</button>
          <CaretRight size={11} weight="bold" />
          <span className="text-foreground">{t.catalog}</span>
        </div>

        <h1 className="mb-8 font-display text-3xl font-black uppercase tracking-tight text-[#2e3a47]" data-testid="catalog-title">{t.catalog}</h1>

        <div className="grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 md:grid-cols-4">
          {ITEMS.map((it) => (
            <button
              key={it.id}
              data-testid={`catalog-cat-${it.id}`}
              onClick={() => navigate(`/shop?category=${it.id}`)}
              className="group flex flex-col items-center rounded-lg p-4 transition"
            >
              <div className="flex h-24 w-24 items-center justify-center">
                <img
                  src={IC + it.icon}
                  alt=""
                  loading="lazy"
                  className="max-h-full max-w-full object-contain transition-transform duration-200 group-hover:scale-110"
                  onError={(e) => { e.currentTarget.style.visibility = "hidden"; }}
                />
              </div>
              <span className="mt-3 text-center text-sm font-bold uppercase leading-snug tracking-wide text-[#2e3a47] transition-colors group-hover:text-primary">
                {label(it)}
              </span>
            </button>
          ))}
        </div>
      </div>

      <ShopFooter />
    </div>
  );
}
